<template>
  <div class="mobile-page">
    <div class="mobile-input">
      <span class="mobile-name">名称</span>
      <el-input
        class="mobile-tools-input"
        placeholder="请输入你的名称"
        v-model="nickname"
        autofocus
      />
    </div>
    <el-input
      type="textarea"
      class="mobile-tools-texrarea"
      placeholder="请输入留言内容"
      v-model="textarea"
      :rows="10"
    />
    <div class="mobile-buttom" @click="push">发表留言</div>
  </div>
</template>
<script>
import { weixinCodeLogin, getUserInfo, addLiuyan } from "@/api/go";
export default {
  name: "",
  props: {},
  computed: {},
  watch: {},
  data() {
    return {
      nickname: "",
      textarea: "",
      token: "",
      userInfo: {},
      query: {}
    };
  },
  methods: {
    push() {
      if (!this.textarea || !this.nickname) {
        this.$message({
          customClass: "mobile-message",
          message: "请完善页面内容",
          type: "warning"
        });

        return;
      }
      addLiuyan({
        userId: Number(this.query.id),
        nickname: this.nickname,
        content: this.textarea
      }).then(() => {
        this.textarea = "";
        this.$message({
          customClass: "mobile-message",
          message: "留言成功",
          type: "success"
        });
      });
    },
    getQuery(name) {
      const reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
      const r = window.location.search.substr(1).match(reg);
      if (r != null) return unescape(r[2]);
      return null;
    },
    getCode() {
      // 如果存在openid，直接return，
      // 当用户获取code后，刷新页面时，获取缓存中的store的情况
      if (this.token) {
        this.getUserInfo();
        return;
      }

      // 检测是否有code
      const urlCode = this.getQuery("code");

      if (!urlCode) {
        // 第一步：用户同意授权，获取code
        // 不存在code
        const appid = "wxf1c8e3a13a37b2fa"; // 微信授权的公众号的AppId'
        const url = location.href;
        const redirectUrl = encodeURIComponent(url);
        window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxf1c8e3a13a37b2fa&redirect_uri=${redirectUrl}&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect`;
      } else if (urlCode) {
        // 有code，且openid为空，进入第二步换取openid
        this.login(urlCode);
      }
      return urlCode;
    },
    login(code) {
      weixinCodeLogin({
        code
      }).then(res => {
        if (res.token) {
          localStorage.setItem("liuyanToken", res.token);
          this.token = res.token;
          this.getUserInfo();
        }
      });
    },
    getUserInfo() {
      getUserInfo().then(res => {
        this.userInfo = res;
        this.nickname = res.nickname;
      });
    }
  },
  created() {
    this.query = this.$route.query;

    this.token = localStorage.getItem("liuyanToken");
    this.getCode();
  },
  mounted() {}
};
</script>
<style lang="less" scoped>
.mobile-page {
  background: #202124;
  padding: 16px 20px;
  height: 100%;
}
.mobile-input {
  background: #fff;
  padding: 13px 15px;
  border-radius: 6px;
  overflow: hidden;
  display: flex;
}
.mobile-name {
  color: #333333;
  font-size: 15px;
}
.mobile-tools-input {
  border: none;
  flex: 1;
  &::v-deep {
    .el-input__inner {
      border: none;
      text-align: right;
      height: 100%;
      font-size: 15px;
      color: #333333;
    }
  }
}
.mobile-tools-texrarea {
  border-radius: 6px;
  background: #ffffff;
  text-align: left;
  color: #333333;
  font-size: 15px;
  padding: 12px;
  border: none;
  resize: none;
  margin-top: 16px;
  &::v-deep {
    .el-textarea__inner {
      border: none;
      height: 258px;
    }
  }
}
.mobile-buttom {
  border-radius: 8px;
  opacity: 1;
  color: #202124;
  font-size: 17px;
  line-height: 53px;
  font-weight: bold;
  text-align: center;
  background: linear-gradient(279deg, #2cfab2 1%, #eef1d2 100%);
  margin-top: 16px;
}
</style>
